import React from 'react'

const Portfolio = () => {
  return (
    <div className='bg-portfolio-bg h-fit lg:h-[120vh] px-6 md:px-12 lg:px-36 py-16 lg:py-12 w-full bg-cover bg-center'>
       <div className=' h-full flex flex-col gap-4 lg:gap-2 justify-center'>
        <h1 className='text-4xl md:text-5xl text-[#fff] font-mosk700' >Portfolio <span className='font-mosk300' >Showreel 2024</span></h1>
        <iframe className='h-[30vh] lg:h-[80%] rounded-lg' src="https://www.youtube.com/embed/4v_oD0bXPkk?si=z8hCR6avs2kYu4lN" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
       </div>
    </div>
  )
}

export default Portfolio
